/**
 * Maps a `promoId` (sent in the qual) to a microsite `micrositeCode`.
 *
 * As we move towards the config tool, configs will be looked up by promoId
 * rather than microsite code. This mapping is the intermediary step that lets
 * the PoweredBy SDK pass a promoId in the qual and have the Provider App resolve
 * the correct microsite config (see `getMicrositeConfigFromPromoId`).
 *
 * Continue to update this mapping as new promoIds are onboarded prior to the config tool rollout.
 */
export const promoIdToMicrosite: Record<string, string> = {
  '5001133': 'cox_branded', // Cox - D2C Brand Search (Position 3)
  '5001599': 'Windstream', // Kinetic - D2C Brand Search (microsite branding was changed, but not the micrositeCode/name)
  '5001177': 'Cincinnati Bell', // Cincinnati Bell (altafiber) - D2C Brand Search
  '5001198': 'spectrum', // Spectrum - D2C Generic Search
  '5001201': 'Comcast', // Xfinity - D2C Generic Search
  '5001823': 'Comcast', // Xfinity - Local Pages (LUM-525)
  '5001214': 'ATT', // AT&T - D2C Generic Search
  '5001237': 'CenturyLink', // CenturyLink - D2C Generic Search
  '5001465': 'wow', // WOW! - No Campaign
  '5001511': 'cox_generic', // Cox - D2C Generic Search
  '5002198': 'Updater', // Updater.com/internet - D2C Generic Search
  '5002260': 'earthlink', // Earthlink - Full Order
  '5002306': 'directv', // DirecTV - directvspecials.com
  '5002308': 'Frontier', // Frontier - FrontierAuthorizedOffers
  '5002341': 'Optimum', // Optimum - D2C Generic Search
  '5002355': 'Brightspeed', // Brightspeed - D2C Generic
  '5002363': 'Brightspeed', // Brightspeed - D2C Branded Tier 2
  '5002366': 'Brightspeed', // Brightspeed - D2C Branded Tier 1
  '5002372': 'DishIFrame', // DISH IFramed
  '5002376': 'Verizon', // Verizon - D2C Generic
  '5002405': 'xfinitypartner', // Cordless - Xfinity - D2C Generic Search
  '5002406': 'coxpartner', // Cordless - Cox - D2C Generic Search
  '5002415': 'quantumfiber', // Quantum Fiber - D2C Generic Search
  '5002435': 'centerfield', // Centerfield - Xfinity Partner
  '5002438': 'adaction', // AdAction - Xfinity Partner
  '5002441': 'AppFolio', // AppFolio
  '5002457': 'adactionspectrumpartner', // AdAction - Spectrum Partner
  '5002459': 'adactionattpartner', // AdAction - AT&T Partner
  '5002465': 'cordlessattpartner', // Cordless - AT&T - D2C Generic Search
  '5002473': 'ratepartner', // Rate EasyLink - PoweredBy Partner
  '5002585': 'ShopLikeSamIFrame', // ShopLikeSam Embed - PoweredBy Partner
  '5002625': 'StarryIFrame', // Starry Embed - PoweredBy Partner
  '5002644': 'PitchItIFrame', // Pitchit Embed - PoweredBy Partner
  '5002646': 'YardiEmbed', // Yardi Embed - PoweredBy Partner
  '5001724': 'SatCoXfinity', // SatCo - Xfinity Partner
  '5001725': 'RealPageEmbed', // RealPage Embed - PoweredBy Partner
  '5002970': 'ApartmentList', // ApartmentList EasyLink - PoweredBy Partner
  '5003072': 'MyDishIFrame', // MyDISH IFramed
  '5010007': 'cox_authorized', // Cox Authorized Offers - D2C Brand
  '5030144': 'tds', // TDS - No Campaign
};
